(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryggupp-kampanjrad"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bars = document.querySelectorAll('.tka');
    if (!bars.length) return;
    const wrappers = [];
    bars.forEach((bar) => {
      const wrapper = bar.closest('.shopify-section');
      if (wrapper) {
        wrapper.classList.add('tka-sticky-section');
        wrappers.push(wrapper);
      }
    });
    const header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('.section-header') || document.querySelector('header');
    const updateTop = () => {
      const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      wrappers.forEach((wrapper) => wrapper.style.setProperty('--tka-top', `${top}px`));
    };
    updateTop();
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('resize', updateTop);
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateTop).observe(header);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryggupp-product-story"] && !Shopify.designMode) return;
  try {
    
  const setupTrygguppStoryVideos = (root = document) => {
    root.querySelectorAll('.tryggupp-story__video-element').forEach((video) => {
      if (video.dataset.trygguppVideoReady === 'true') return;

      video.dataset.trygguppVideoReady = 'true';
      video.muted = true;
      video.controls = false;
      video.disablePictureInPicture = true;
      video.addEventListener('contextmenu', (event) => event.preventDefault());

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: [0, 0.35, 0.75] });

      observer.observe(video);
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.tryggupp-story__review-trigger');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('.tryggupp-story__review-close');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('.tryggupp-story__review-dialog')) {
      event.target.close();
    }
  });

  const openSubmittedReviewForm = () => {
    document.querySelectorAll('.tryggupp-story__review-dialog').forEach((dialog) => {
      if (dialog.querySelector('.tryggupp-story__form-success, .errors') && !dialog.open) {
        dialog.showModal();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', openSubmittedReviewForm);
  document.addEventListener('DOMContentLoaded', () => setupTrygguppStoryVideos());
  document.addEventListener('shopify:section:load', openSubmittedReviewForm);
  document.addEventListener('shopify:section:load', (event) => setupTrygguppStoryVideos(event.target));
  setupTrygguppStoryVideos();

  } catch(e) { console.error(e); }
})();
})();
